import * as React from 'react';
import { SyntheticEvent } from 'react';

interface Props {
    labelProps: {
        labelText?: string;
        invalidText?: string;
        removeBoldFont?: boolean;
    };
    inputProps: {
        id: string;
        type?: string;
        name: string;
        placeholder?: string;
        required?: boolean;
        value?: string | number;
        pattern?: string;
        mask?: string;
        minLength?: number;
        maxLength?: number;
        disabled?: boolean;
        min?: string;
        max?: string;
        readOnly?: boolean;
    };
    helpTextProps?: {
        helpText: string;
        helpTextClass?: string;
    };
    onChange: (inputName: string, newValue: string | number) => void;
    inline?: boolean;
    controlCssClass?: string;
    setShowPropertyScanner: any;
}

const FormInputWithButton = (props: Props) => {
    const inputChanged = (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        props.onChange(props.inputProps.name, e.currentTarget.value);
    };
    let additionalGroupClasses = `${props.controlCssClass || ''}${props.inline ? ' row' : ''}`;
    let label = (
        <label
            htmlFor={props.inputProps.id}
            className={`${props.labelProps.removeBoldFont ? '' : 'font-weight-bold'}${
                props.inline ? ' col' : ''
                }`}
        >
            {props.labelProps.labelText === null ||
                props.labelProps.labelText === undefined ||
                props.labelProps.labelText === '' ? (
                    <>&nbsp;</>
                ) : (
                    props.labelProps.labelText
                )}
        </label>
    );
    return (
        <div className={'form-group ' + additionalGroupClasses}>
            {props.labelProps.labelText && label}
            {/* Only use the InputMask component if a mask was specified */}
            <div style={{ display: 'flex', gap: '8px' }}>
                <input
                    {...props.inputProps}
                    onChange={inputChanged}
                    value={props.inputProps.value || ''}
                    className={`form-control${props.inline ? ' col' : ''}`}
                /> 
                <button type='button' style={{ marginRight: '18px', marginTop: '0px' }} className="load-unit-admin btn-primary btn font-weight-bold" onClick={()=>{props.setShowPropertyScanner(true);}}>
                    QR Code
                </button>
            </div> 
        </div>
    );
};

export default FormInputWithButton;



// WEBPACK FOOTER //
// ./src/components/common/form/InputWithButton.tsx